/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pro_User_Appreciation_Letter_Bald_Cypress_Body5Inputs */

const en_pro_user_appreciation_letter_bald_cypress_body5 = /** @type {(inputs: Pro_User_Appreciation_Letter_Bald_Cypress_Body5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not only that, we have also prepared a new "land" for the Bald Cypress!`)
};

const ar_pro_user_appreciation_letter_bald_cypress_body5 = /** @type {(inputs: Pro_User_Appreciation_Letter_Bald_Cypress_Body5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ليس ذلك فحسب، بل أعددنا أيضًا "أرضًا" جديدة لـ شجرة السرو الأصلع!`)
};

const de_pro_user_appreciation_letter_bald_cypress_body5 = /** @type {(inputs: Pro_User_Appreciation_Letter_Bald_Cypress_Body5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nicht nur das, wir haben auch ein neues "Land" für die Sumpfzypressevorbereitet!`)
};

const es_pro_user_appreciation_letter_bald_cypress_body5 = /** @type {(inputs: Pro_User_Appreciation_Letter_Bald_Cypress_Body5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Y no solo eso, sino que también hemos preparado un nuevo "terreno" para el Ciprés calvo!`)
};

const fr_pro_user_appreciation_letter_bald_cypress_body5 = /** @type {(inputs: Pro_User_Appreciation_Letter_Bald_Cypress_Body5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Et ce n'est pas tout ! Nous avons également préparé un nouveau «sol» pour le Cyprès Chauve !`)
};

const it_pro_user_appreciation_letter_bald_cypress_body5 = /** @type {(inputs: Pro_User_Appreciation_Letter_Bald_Cypress_Body5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non solo, abbiamo anche preparato un nuovo "terreno" per il Cipresso Calvo!`)
};

const ja_pro_user_appreciation_letter_bald_cypress_body5 = /** @type {(inputs: Pro_User_Appreciation_Letter_Bald_Cypress_Body5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`さらに、ラクウショウのための新たな「ランド」もご用意しました！`)
};

const ko_pro_user_appreciation_letter_bald_cypress_body5 = /** @type {(inputs: Pro_User_Appreciation_Letter_Bald_Cypress_Body5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`뿐만 아니라 낙우송을 위한 새로운 "땅"까지 준비했답니다!`)
};

const pt_br_pro_user_appreciation_letter_bald_cypress_body5 = /** @type {(inputs: Pro_User_Appreciation_Letter_Bald_Cypress_Body5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não apenas isso, mas também preparamos um novo "terreno" para Pinheiro-do-Brejo!`)
};

const ru_pro_user_appreciation_letter_bald_cypress_body5 = /** @type {(inputs: Pro_User_Appreciation_Letter_Bald_Cypress_Body5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Более того, мы также подготовили новую «землю» для Таксодиума двурядного!`)
};

const th_pro_user_appreciation_letter_bald_cypress_body5 = /** @type {(inputs: Pro_User_Appreciation_Letter_Bald_Cypress_Body5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ยิ่งไปกว่านั้น เรายังได้เตรียม "ผืนดิน" ใหม่สำหรับสนหัวโล้นไว้ให้ด้วย!`)
};

const tr_pro_user_appreciation_letter_bald_cypress_body5 = /** @type {(inputs: Pro_User_Appreciation_Letter_Bald_Cypress_Body5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yalnızca bununla da kalmadık, Bataklık Selvisi için yeni bir "arazi" de hazırladık!`)
};

const zh_cn_pro_user_appreciation_letter_bald_cypress_body5 = /** @type {(inputs: Pro_User_Appreciation_Letter_Bald_Cypress_Body5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不只有树，我们还帮落羽杉准备了一个新家！`)
};

const zh_tw_pro_user_appreciation_letter_bald_cypress_body5 = /** @type {(inputs: Pro_User_Appreciation_Letter_Bald_Cypress_Body5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`不只有樹，我們還幫落羽松準備了一個新家！`)
};

/**
* | output |
* | --- |
* | "Not only that, we have also prepared a new \"land\" for the Bald Cypress!" |
*
* @param {Pro_User_Appreciation_Letter_Bald_Cypress_Body5Inputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const pro_user_appreciation_letter_bald_cypress_body5 = /** @type {((inputs?: Pro_User_Appreciation_Letter_Bald_Cypress_Body5Inputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pro_User_Appreciation_Letter_Bald_Cypress_Body5Inputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pro_user_appreciation_letter_bald_cypress_body5(inputs)
	if (locale === "ar") return ar_pro_user_appreciation_letter_bald_cypress_body5(inputs)
	if (locale === "de") return de_pro_user_appreciation_letter_bald_cypress_body5(inputs)
	if (locale === "es") return es_pro_user_appreciation_letter_bald_cypress_body5(inputs)
	if (locale === "fr") return fr_pro_user_appreciation_letter_bald_cypress_body5(inputs)
	if (locale === "it") return it_pro_user_appreciation_letter_bald_cypress_body5(inputs)
	if (locale === "ja") return ja_pro_user_appreciation_letter_bald_cypress_body5(inputs)
	if (locale === "ko") return ko_pro_user_appreciation_letter_bald_cypress_body5(inputs)
	if (locale === "pt_br") return pt_br_pro_user_appreciation_letter_bald_cypress_body5(inputs)
	if (locale === "ru") return ru_pro_user_appreciation_letter_bald_cypress_body5(inputs)
	if (locale === "th") return th_pro_user_appreciation_letter_bald_cypress_body5(inputs)
	if (locale === "tr") return tr_pro_user_appreciation_letter_bald_cypress_body5(inputs)
	if (locale === "zh_cn") return zh_cn_pro_user_appreciation_letter_bald_cypress_body5(inputs)
	return zh_tw_pro_user_appreciation_letter_bald_cypress_body5(inputs)
});